export const toLowerCaseString = (inputString?: string): string => {
  if (inputString) {
    return inputString.toLowerCase();
  }
  return "";
};
export const toUpperCaseString = (inputString?: string): string => {
  if (inputString) {
    return inputString.toUpperCase();
  }
  return "";
};

export const toPascalCaseString = (inputString?: string): string => {
  if (inputString) {
    return inputString
      .replace(/[\s_.-]+\w/g, (m) => (m[m.length - 1] as string).toUpperCase())
      .replace(inputString.charAt(0), inputString.charAt(0).toUpperCase());
  }
  return "";
};
export const toUpperCaseReplaceSpaceString = (inputString?: string): string => {
  if (inputString) {
    return inputString.toUpperCase().replace(/\s+/g, "");
  }
  return "";
};

export const replaceNewLineWithBR = (inputString: string): string =>
  inputString.replace(/\n/g, "<br>");

export const capitalizeFirstLetter = (inputString: string): string => {
  if (!inputString) {
    return inputString; // Return unchanged if the input is empty or null
  }

  const firstLetter = inputString.charAt(0).toUpperCase();
  const restOfString = inputString.slice(1);

  return firstLetter + restOfString;
};

export const trimString = (value?: string) => {
  if (value) {
    value.trim();
  }
  return "";
};

export const humanize = (str: string) => {
  return str
    .trim()
    .split(/\s+/)
    .map((word) => {
      return word.replace(/_/g, " ").replace(/\s+/, " ").trim();
    })
    .join(" ")
    .toLowerCase()
    .replace(/^./, (m) => {
      return m.toUpperCase();
    });
};

export const capitalizeUsingRegex = (str: string) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};
